<template>
  <div class="alert alert-warning m-0">
    Bu kural her zaman <u>doğru (true)</u> olarak döner. Eğer sadece <b>x olduğu zaman</b> kuralın geçmesini istiyorsanız kullanabilirsiniz. Yani bu kural geçersiz elemandır.
  </div>
</template>

<script>
export default {
  props: ["value"],
  components: {},
  computed: {},
  methods: {},
};
</script>
